const { default: PageError } = require("pages/PageError");
const { default: FrontendLayout } = require("pages/frontend/FrontendLayout");
const { resetCurrentPage } = require("redux/store");

export const getRoute = (routeObj = {}) => {
    return {
        ...routeObj, 
        loader: () => resetCurrentPage(), 
        errorElement: (
            <FrontendLayout 
                children={<PageError />} 
                bypassAuthCheck={true} 
            />
        ) 
    };
};